/* SOFAPRESTO — JS global du thème (vanilla, zéro dépendance hors Lenis).
   Port 1:1 des comportements du site Next : Lenis 1.1s ease-out cubique,
   header morph, tiroir nav, carrousel annonce 4,2 s, reveals -8% + délais,
   reel 5 s/4,5 s, toggle lit 3,2 s, zig-zag filtres/tri, parallax marquee,
   FAQ animée, lien « Gérer mes cookies », curseur, panier AJAX (tiroir + palier cadeau),
   fiche produit (galerie curée, variantes, count-up, magnétique, fly-to-cart,
   buybar, lightbox, schéma). Tout est gelé sous prefers-reduced-motion. */
(function () {
  'use strict';
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.16,1,.3,1)';
  var sortieCubique = function (t) { return 1 - Math.pow(1 - t, 3); };

  /* ── Lenis (durée/easing du site) ── */
  if (!rm && window.Lenis) {
    window.__lenis = new window.Lenis({
      autoRaf: true, duration: 1.1, easing: sortieCubique, smoothWheel: true
    });
  }

  /* ── Monnaie : format dérivé d'un échantillon Liquid (ex. €1.190,00) ── */
  var formateMonnaie = function (cents, echantillon) {
    var entier = Math.round(cents / 100);
    var groupes = String(entier).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var decimales = (echantillon && echantillon.indexOf(',') > -1) ? ',00' : '';
    var prefixe = (echantillon && /^[^0-9]*€/.test(echantillon)) ? '€' : '';
    var suffixe = (!prefixe) ? ' €' : '';
    return prefixe + groupes + decimales + suffixe;
  };
  var countUpMonnaie = function (el, deCents, versCents, echantillonFinal) {
    if (rm || Math.abs(versCents - deCents) < 1) { el.textContent = echantillonFinal; return; }
    var debut = null;
    var pas = function (ts) {
      if (!debut) debut = ts;
      var t = Math.min(1, (ts - debut) / 700);
      var v = deCents + (versCents - deCents) * sortieCubique(t);
      el.textContent = t < 1 ? formateMonnaie(v, echantillonFinal) : echantillonFinal;
      if (t < 1) requestAnimationFrame(pas);
    };
    requestAnimationFrame(pas);
  };

  /* ── Header compact / caché ── */
  var header = document.querySelector('.sfp-header');
  if (header) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('est-compacte', y > 80);
      var ouvert = document.querySelector('.sfp-drawer.est-ouvert, .sfp-panier.est-ouvert');
      header.classList.toggle('est-cachee', y > 160 && y > lastY && !ouvert);
      lastY = y;
    }, { passive: true });
  }

  /* ── Tiroir nav ── */
  var drawer = document.querySelector('.sfp-drawer');
  var burger = document.querySelector('[data-sfp-burger]');
  if (drawer && burger) {
    var fermeNav = function () {
      drawer.classList.remove('est-ouvert');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', function () {
      var ouvert = drawer.classList.toggle('est-ouvert');
      burger.setAttribute('aria-expanded', String(ouvert));
      document.body.style.overflow = ouvert ? 'hidden' : '';
    });
    drawer.querySelectorAll('[data-sfp-ferme]').forEach(function (el) {
      el.addEventListener('click', fermeNav);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermeNav();
    });
  }

  /* ── Bandeau annonce : carrousel 4,2 s + flèches ── */
  document.querySelectorAll('[data-sfp-annonce]').forEach(function (annonce) {
    var msgs = annonce.querySelectorAll('.sfp-annonce__msg');
    if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add('est-active'); return; }
    var i = 0, timer = null;
    msgs[0].classList.add('est-active');
    var montre = function (suivant) {
      var actuel = msgs[i];
      actuel.classList.remove('est-active');
      actuel.classList.add('est-sortant');
      setTimeout(function () { actuel.classList.remove('est-sortant'); }, 300);
      i = (suivant + msgs.length) % msgs.length;
      msgs[i].classList.add('est-active');
    };
    var programme = function () {
      clearInterval(timer);
      if (!rm) timer = setInterval(function () { montre(i + 1); }, 4200);
    };
    annonce.querySelectorAll('[data-sens]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        montre(i + Number(btn.dataset.sens)); programme();
      });
    });
    programme();
  });

  /* ── Hero reel : crossfade auto (1er 5 s puis 4,5 s), pause hors écran ── */
  document.querySelectorAll('[data-sfp-reel]').forEach(function (reel) {
    var slides = reel.querySelectorAll('.sfp-reel__slide');
    if (slides.length < 2 || rm) return;
    var i = 0, timer = null, enVue = true;
    var suivant = function () {
      slides[i].classList.remove('est-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('est-active');
      programme(4500);
    };
    var programme = function (delai) {
      clearTimeout(timer);
      if (enVue) timer = setTimeout(suivant, delai);
    };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        enVue = entries[0].isIntersecting;
        if (enVue) programme(4500); else clearTimeout(timer);
      }, { threshold: 0.05 }).observe(reel);
    }
    programme(5000);
  });

  /* ── Défilement doux vers #collection ── */
  document.querySelectorAll('[data-sfp-scroll-collection]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cible = document.getElementById('collection');
      if (!cible) return;
      if (window.__lenis) window.__lenis.scrollTo(cible, { duration: 1.1 });
      else cible.scrollIntoView({ behavior: rm ? 'auto' : 'smooth' });
    });
  });

  /* ── Toggle « plié / lit » : pause au survol SEULEMENT (l'auto reprend après clic) ── */
  document.querySelectorAll('[data-sfp-toggle]').forEach(function (racine) {
    var imgs = racine.querySelectorAll('img[data-etat]');
    var boutons = racine.querySelectorAll('.sfp-toggle__btn');
    var label = racine.querySelector('[data-sfp-toggle-label]');
    var dim = racine.querySelector('[data-sfp-toggle-dim]');
    var etat = 'plie', timer = null;
    var applique = function (nouveau) {
      etat = nouveau;
      imgs.forEach(function (im) { im.classList.toggle('est-active', im.dataset.etat === etat); });
      boutons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.etat === etat)); });
      if (label) label.textContent = etat === 'lit' ? 'Le lit' : racine.dataset.labelPlie;
      if (dim) dim.textContent = etat === 'lit' ? racine.dataset.dimLit : racine.dataset.dimPlie;
    };
    var programme = function () {
      clearTimeout(timer);
      if (!rm) timer = setTimeout(function () {
        applique(etat === 'plie' ? 'lit' : 'plie');
        programme();
      }, 3200);
    };
    boutons.forEach(function (b) {
      b.addEventListener('click', function () { applique(b.dataset.etat); programme(); });
    });
    racine.addEventListener('mouseenter', function () { clearTimeout(timer); });
    racine.addEventListener('mouseleave', function () { programme(); });
    racine.__sfpReset = function () { applique('plie'); programme(); };
    programme();
  });

  /* ── LitTransition (/collection) : sélecteur 5 modèles ── */
  document.querySelectorAll('[data-sfp-lit-transition]').forEach(function (racine) {
    var boutons = racine.querySelectorAll('[data-modele]');
    var blocs = racine.querySelectorAll('[data-sfp-lit-bloc]');
    boutons.forEach(function (b) {
      b.addEventListener('click', function () {
        boutons.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        blocs.forEach(function (bloc) {
          var actif = bloc.dataset.sfpLitBloc === b.dataset.modele;
          bloc.hidden = !actif;
          var toggle = bloc.querySelector('[data-sfp-toggle]');
          if (actif && toggle && toggle.__sfpReset) toggle.__sfpReset();
        });
      });
    });
  });

  /* ── Zig-zag : filtres (+ tri prix, hint modèles, deep-link ?type=) ── */
  var realterne = function (zigzag) {
    var visibles = Array.prototype.filter.call(zigzag.children, function (el) {
      return el.hasAttribute('data-type') && !el.hidden;
    });
    visibles.forEach(function (wrapper, idx) {
      var ligne = wrapper.querySelector('.sfp-zigzag__ligne');
      if (!ligne) return;
      var imgdroite = idx % 2 === 0;
      ligne.classList.toggle('sfp-zigzag__ligne--imgdroite', imgdroite);
      var img = ligne.querySelector('.sfp-zigzag__img');
      var texte = null;
      Array.prototype.forEach.call(ligne.children, function (c) { if (c !== img) texte = c; });
      if (img) {
        img.style.order = imgdroite ? '2' : '1';
        img.classList.remove('sfp-reveal--gauche', 'sfp-reveal--droite');
        img.classList.add(imgdroite ? 'sfp-reveal--droite' : 'sfp-reveal--gauche');
      }
      if (texte) {
        texte.style.order = imgdroite ? '1' : '2';
        texte.classList.remove('sfp-reveal--txt-gauche', 'sfp-reveal--txt-droite');
        texte.classList.add(imgdroite ? 'sfp-reveal--txt-gauche' : 'sfp-reveal--txt-droite');
      }
    });
  };
  document.querySelectorAll('[data-sfp-filtres]').forEach(function (groupe) {
    var section = groupe.closest('section, [data-sfp-collection]') || document;
    var zigzag = section.querySelector('[data-sfp-zigzag]');
    if (!zigzag) return;
    var boutons = groupe.querySelectorAll('[data-filtre]');
    var hint = section.querySelector('[data-sfp-filtre-hint]');
    var applique = function (filtre) {
      boutons.forEach(function (b) {
        var actif = b.dataset.filtre === filtre;
        b.setAttribute('aria-pressed', String(actif));
        b.classList.toggle('pill--ghost', !actif);
        if (actif && hint && b.dataset.hint) hint.textContent = b.dataset.hint;
      });
      Array.prototype.forEach.call(zigzag.children, function (el) {
        if (!el.hasAttribute('data-type')) return;
        el.hidden = filtre !== 'tous' && el.dataset.type !== filtre;
      });
      realterne(zigzag);
    };
    boutons.forEach(function (b) {
      b.addEventListener('click', function () { applique(b.dataset.filtre); });
    });
    var type = new URLSearchParams(location.search).get('type');
    var initial = null;
    if (type) initial = groupe.querySelector('[data-filtre="' + type + '"]');
    if (!initial) initial = groupe.querySelector('[data-filtre][aria-pressed="true"]');
    if (initial) applique(initial.dataset.filtre);

    var tri = section.querySelector('[data-sfp-tri]');
    if (tri) {
      tri.addEventListener('click', function () {
        var sens = tri.dataset.sens === 'asc' ? 'desc' : 'asc';
        tri.dataset.sens = sens;
        tri.innerHTML = sens === 'asc' ? 'Prix croissant <span aria-hidden="true">↑</span>' : 'Prix décroissant <span aria-hidden="true">↓</span>';
        Array.prototype.slice.call(zigzag.children)
          .filter(function (el) { return el.hasAttribute('data-prix'); })
          .sort(function (a, b) {
            var d = Number(a.dataset.prix) - Number(b.dataset.prix);
            return sens === 'asc' ? d : -d;
          })
          .forEach(function (el) { zigzag.appendChild(el); });
        realterne(zigzag);
      });
    }
  });

  /* ── Parallax de la galerie marquee (+48px → -48px) ── */
  document.querySelectorAll('[data-sfp-parallax]').forEach(function (wrapper) {
    if (rm) return;
    var maj = function () {
      var r = wrapper.getBoundingClientRect();
      var p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
      p = Math.max(0, Math.min(1, p));
      wrapper.style.transform = 'translateY(' + (48 - 96 * p) + 'px)';
    };
    window.addEventListener('scroll', function () { requestAnimationFrame(maj); }, { passive: true });
    maj();
  });

  /* ── FAQ : un seul ouvert, ouverture/fermeture animées (height + opacity .3s) ── */
  document.querySelectorAll('.sfp-faq').forEach(function (faq) {
    var items = faq.querySelectorAll('details');
    items.forEach(function (det) {
      var resume = det.querySelector('summary');
      var corps = det.querySelector('summary + div, div');
      if (!resume || !corps) return;
      resume.addEventListener('click', function (e) {
        e.preventDefault();
        if (rm || !corps.animate) {
          items.forEach(function (o) { if (o !== det) o.removeAttribute('open'); });
          det.open = !det.open;
          return;
        }
        if (det.open) {
          var h0 = corps.offsetHeight;
          corps.animate([{ height: h0 + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
            { duration: 300, easing: EASE }).onfinish = function () { det.open = false; };
        } else {
          items.forEach(function (o) {
            if (o !== det && o.open) {
              var oc = o.querySelector('summary + div, div');
              if (oc && oc.animate) {
                oc.animate([{ height: oc.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
                  { duration: 300, easing: EASE }).onfinish = function () { o.open = false; };
              } else o.open = false;
            }
          });
          det.open = true;
          var h1 = corps.offsetHeight;
          corps.animate([{ height: '0px', opacity: 0 }, { height: h1 + 'px', opacity: 1 }],
            { duration: 300, easing: EASE });
        }
      });
    });
  });

  /* ── « Gérer mes cookies » : rouvre les préférences du bandeau Shopify
     (retirer son accord doit être aussi simple que le donner). Sans le script
     du bandeau, le lien mène à la page Cookies, qui rouvre les préférences. ── */
  var ouvrePreferencesCookies = function () {
    var essais = 0;
    (function tente() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else if (++essais < 25) {
        setTimeout(tente, 200);
      }
    })();
  };
  document.addEventListener('click', function (e) {
    var lien = e.target.closest && e.target.closest('[data-sfp-cookies], a[href$="#gerer-cookies"]');
    if (!lien || !window.privacyBanner) return;
    e.preventDefault();
    ouvrePreferencesCookies();
  });
  if (location.hash === '#gerer-cookies') ouvrePreferencesCookies();

  /* ── Curseur custom (lerp .22 / .18, ×2.2 sur les interactifs) ── */
  var curseur = document.querySelector('.sfp-curseur');
  if (curseur && !rm && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var mx = -20, my = -20, cx = -20, cy = -20, cible = 1, cscale = 1, vu = false;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!vu) { vu = true; curseur.style.opacity = '.65'; }
      cible = e.target.closest('a,button,[role="button"],input,[aria-pressed]') ? 2.2 : 1;
    }, { passive: true });
    (function boucle() {
      cx += (mx - cx) * 0.22; cy += (my - cy) * 0.22;
      cscale += (cible - cscale) * 0.18;
      curseur.style.transform = 'translate(' + (cx - 5) + 'px,' + (cy - 5) + 'px) scale(' + cscale + ')';
      requestAnimationFrame(boucle);
    })();
  }

  /* ══ PANIER AJAX — parité CartDrawer.jsx du site refait (2026-10-08) ══
     Livraison offerte dès 65 €, Presso offert dès 100 € (hors Presso) : il est
     AJOUTÉ tout seul au panier quand le palier est atteint (la remise
     automatique Shopify le passe à 0 €), retiré s'il ne l'est plus, et jamais
     ré-ajouté si le visiteur l'a retiré lui-même. Coussin + plaid assortis au
     coloris du modèle du panier. Dialogue modal : focus piégé, Échap, page gelée. */
  var panier = document.querySelector('[data-sfp-panier]');
  var euros = function (cents) {
    var v = Math.round(cents) / 100;
    var s = (v % 1 === 0) ? String(v) : v.toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  };
  var majCompteur = function (count) {
    var btn = document.querySelector('[data-sfp-panier-btn]');
    if (!btn) return;
    btn.setAttribute('aria-label', 'Panier, ' + count + ' article(s)');
    var badge = btn.querySelector('.sfp-header__compteur');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'sfp-header__compteur tnum';
        btn.appendChild(badge);
      }
      badge.innerHTML = '<span>' + count + '</span>';
      badge.classList.remove('est-pop');
      void badge.offsetWidth;
      badge.classList.add('est-pop');
    } else if (badge) badge.remove();
  };
  var ouvrePanier = null;
  if (panier) {
    var D = panier.dataset;
    var PRESSO = Number(D.presso), SEUIL_PRESSO = 10000, SEUIL_LIVRAISON = 6500, FRAIS = 799;
    var MODELES = ['halden', 'sander', 'bergen', 'froya', 'lykke'];
    var q = function (s) { return panier.querySelector(s); };
    var lignes = q('[data-sfp-panier-lignes]'), assortis = q('[data-sfp-assortis]');
    var corps = q('[data-sfp-panier-corps]'), vide = q('[data-sfp-panier-vide]'), pied = q('[data-sfp-panier-pied]');
    var titre = q('[data-sfp-panier-titre]'), gift = q('[data-sfp-gift]'), livraison = q('[data-sfp-livraison]');
    var articles = q('[data-sfp-articles]'), remiseLigne = q('[data-sfp-remise-ligne]'), remise = q('[data-sfp-remise]');
    var remiseNom = q('[data-sfp-remise-nom]'), frais = q('[data-sfp-frais]'), total = q('[data-sfp-sous-total]');
    var commander = q('[data-sfp-commander]'), estimation = q('[data-sfp-estimation]');
    var declencheur = null, dernierTotal = 0, ajoutRecent = { ids: [], t: 0 };
    var lit = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
    var note = function (k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* stockage bloqué */ } };
    var estPresso = function (it) { return it.variant_id === PRESSO; };
    var ACCORDS = {
      Noir: ['terracotta', 'creme'], Gris: ['terracotta', 'creme'], Vert: ['terracotta', 'creme'],
      Blanc: ['sauge', 'camel'], 'Crème': ['sauge', 'camel']
    };
    var NOMS = { terracotta: 'Terracotta', sauge: 'Sauge', creme: 'Crème', camel: 'Camel' };
    /* Packs (11-10) : déclinaisons [id, [couleurs]], prix du pack et prix des pièces séparées */
    var PACKS = {};
    try { PACKS = JSON.parse(panier.querySelector('[data-sfp-packs]').textContent); } catch (e) { /* pas de packs */ }
    var suggestionPack = q('[data-sfp-pack-suggestion]');
    var varPack = function (h, couleurs) {
      var pk = PACKS[h]; if (!pk) return null;
      for (var i = 0; i < pk.v.length; i++) {
        if (pk.v[i][1].join('|') === couleurs.join('|')) return pk.v[i][0];
      }
      return null;
    };
    var couleurDe = function (it, nom) {
      var c = null;
      (it.options_with_values || []).forEach(function (o) { if (o.name === nom) c = o.value; });
      return c;
    };
    if (estimation) {
      var jour = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }); };
      estimation.textContent = 'entre le ' + jour(21) + ' et le ' + jour(28);
    }

    var fermePanier = function () {
      panier.classList.remove('est-ouvert');
      document.documentElement.style.overflow = '';
      if (window.__lenis) window.__lenis.start();
      if (declencheur) declencheur.focus();
    };
    var html = function (s) { var e = document.createElement('span'); e.textContent = s; return e.innerHTML; };

    var rendu = function (cart) {
      majCompteur(cart.item_count);
      var estVide = cart.item_count === 0;
      titre.textContent = 'Votre panier' + (estVide ? '' : ' (' + cart.item_count + ')');
      vide.hidden = !estVide; corps.hidden = estVide; pied.hidden = estVide;

      var net = 0, modele = null, presente = {};
      cart.items.forEach(function (it) {
        presente[it.variant_id] = true;
        if (!estPresso(it)) net += it.final_line_price;
        if (!modele && MODELES.indexOf(it.handle) > -1) modele = it;
      });

      /* Livraison offerte (seuil 65 €) */
      if (cart.total_price >= SEUIL_LIVRAISON) {
        livraison.innerHTML = '<span style="color:var(--green);font-weight:600;">Livraison offerte <span aria-hidden="true">✓</span></span>';
      } else {
        var pctL = Math.min(100, net / SEUIL_LIVRAISON * 100);
        livraison.innerHTML = 'Plus que <strong class="tnum">' + euros(SEUIL_LIVRAISON - cart.total_price) + '</strong> pour la livraison offerte <span style="color:var(--fg-soft)">(sinon ' + euros(FRAIS) + ')</span>' +
          '<span class="sfp-panier__rail" role="progressbar" aria-label="Livraison offerte dès 65 €" aria-valuemin="0" aria-valuemax="65" aria-valuenow="' + Math.round(net / 100) + '"><span style="width:' + pctL + '%"></span></span>';
      }
      /* Presso (seuil 100 € hors Presso) */
      var gagne = net >= SEUIL_PRESSO;
      var texte = gift.querySelector('.sfp-gift__texte'), barre = gift.querySelector('.sfp-gift__barre');
      barre.style.width = Math.min(100, net / SEUIL_PRESSO * 100) + '%';
      texte.innerHTML = gagne
        ? '<span>Presso vous est offert.</span><span class="sfp-gift__badge">OFFERT</span>'
        : '<span>Plus que <strong class="tnum">' + euros(SEUIL_PRESSO - net) + '</strong> et Presso vous est offert</span>';

      /* Lignes : Presso d'abord */
      var tri = cart.items.slice().sort(function (a, b) { return (estPresso(b) ? 1 : 0) - (estPresso(a) ? 1 : 0); });
      lignes.innerHTML = '';
      tri.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'sfp-panier__ligne';
        var ecoule = Date.now() - ajoutRecent.t;
        if (ajoutRecent.ids.indexOf(item.variant_id) > -1 && ecoule < 2300) {
          li.classList.add('est-nouvelle');
          if (ecoule > 60) li.style.animationDelay = '-' + ecoule + 'ms, -' + ecoule + 'ms';
        }
        var offert = estPresso(item) && item.final_line_price === 0;
        var nom = (item.product_title || '').split(' — ')[0];
        var pk = PACKS[item.handle];
        var opts = (item.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; })
          .map(function (o) { return pk ? o.name + ' : ' + o.value : o.value; }).join(' · ');
        var ecoPack = pk ? pk.sep * item.quantity - item.final_line_price : 0;
        var img = estPresso(item) ? D.imgPresso : (item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=144' : '');
        /* Pack : les carrés de tissu des couleurs choisies, pas la photo générique */
        var compoPack = '';
        if (pk && PACKS._tissus) {
          compoPack = '<span class="sfp-panier__compo" aria-hidden="true">' + (item.options_with_values || []).map(function (o) {
            var src = (PACKS._tissus[o.name.indexOf('Plaid') === 0 ? 'plaid' : 'coussin'] || {})[o.value];
            return src ? '<img src="' + src + '" alt="" width="24" height="72">' : '';
          }).join('') + '</span>';
        }
        var prix = offert
          ? '<span class="sfp-panier__offert tnum">0&nbsp;€<span class="sr-only">, offert</span></span>'
          : '<span class="tnum" style="font-weight:600;">' + euros(item.final_line_price) + '</span>';
        var sous = estPresso(item)
          ? '<p class="sfp-panier__ligne-opts" style="color:' + (offert ? 'var(--terra)' : 'var(--fg-soft)') + '">' + (offert ? 'Cadeau, offert dès 100&nbsp;€ d\'achat' : 'Offert dès 100&nbsp;€ d\'achat (hors Presso)') + '</p>'
          : (opts ? '<p class="sfp-panier__ligne-opts">' + html(opts) + '</p>' : '') +
            (ecoPack > 0 ? '<p class="sfp-panier__ligne-eco">Pack : ' + euros(ecoPack) + ' de moins qu\'à l\'unité</p>' : '');
        var qte = offert ? '' :
          '<span class="sfp-panier__qte">' +
          '<button type="button" data-qte="-1" aria-label="Diminuer la quantité : ' + html(nom) + '">−</button>' +
          '<span class="tnum" aria-label="Quantité : ' + item.quantity + '">' + item.quantity + '</span>' +
          '<button type="button" data-qte="1" aria-label="Augmenter la quantité : ' + html(nom) + '">+</button></span>';
        li.innerHTML =
          (compoPack || (img ? '<img src="' + img + '" alt="" width="72" height="72"' + (estPresso(item) ? ' style="object-fit:contain"' : '') + '>' : '')) +
          '<div class="sfp-panier__ligne-corps">' +
          '<div class="sfp-panier__ligne-haut"><p class="sfp-panier__ligne-nom">' + html(nom) + '</p>' + prix + '</div>' + sous +
          '<div class="sfp-panier__ligne-bas">' + qte +
          '<button type="button" class="sfp-panier__retirer" data-qte="0" aria-label="Retirer ' + html(nom) + ' du panier">Retirer</button></div>' +
          '</div>';
        li.querySelectorAll('[data-qte]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var delta = Number(btn.dataset.qte);
            var qn = delta === 0 ? 0 : item.quantity + delta;
            if (estPresso(item) && qn === 0) { note('sfp-presso-refus', '1'); note('sfp-presso-auto', null); }
            change(item.key, qn);
          });
        });
        lignes.appendChild(li);
      });

      /* Regroupement : des coussins 45 × 45 et un plaid achetés séparément → le pack équivalent, 10 % de moins */
      if (suggestionPack) {
        suggestionPack.innerHTML = '';
        suggestionPack.hidden = true;
        var coussins = [], plaids = [];
        cart.items.forEach(function (it) {
          if (it.handle === 'coussin-velours-cotele' && couleurDe(it, 'Taille') === '45×45') {
            for (var n = 0; n < it.quantity; n++) coussins.push({ cle: it.key, couleur: couleurDe(it, 'Coloris'), prix: it.final_price });
          }
          if (it.handle === 'plaid-cocon') {
            for (var m = 0; m < it.quantity; m++) plaids.push({ cle: it.key, couleur: couleurDe(it, 'Coloris'), prix: it.final_price });
          }
        });
        var choixPack = null;
        if (coussins.length >= 2 && plaids.length >= 1) choixPack = ['le-grand-cocon', [coussins[0], coussins[1], plaids[0]]];
        else if (coussins.length >= 1 && plaids.length >= 1) choixPack = ['le-combo-cocon', [coussins[0], plaids[0]]];
        else if (coussins.length >= 2) choixPack = ['le-duo-velours', [coussins[0], coussins[1]]];
        if (choixPack && PACKS[choixPack[0]]) {
          var pieces = choixPack[1];
          var idPack = varPack(choixPack[0], pieces.map(function (x) { return x.couleur; }));
          var totalPieces = pieces.reduce(function (t, x) { return t + x.prix; }, 0);
          var gain = totalPieces - PACKS[choixPack[0]].prix;
          if (idPack && gain > 0) {
            suggestionPack.hidden = false;
            suggestionPack.innerHTML = '<p><strong>Ces pièces existent en pack.</strong> ' +
              '<a href="' + PACKS[choixPack[0]].url + '">' + html(PACKS[choixPack[0]].nom) + '</a> : mêmes couleurs, ' + euros(gain) + ' de moins.</p>' +
              '<button type="button" class="pill pill--nav sfp-panier__regrouper">Regrouper en pack · −' + euros(gain) + '</button>';
            suggestionPack.querySelector('button').addEventListener('click', function () {
              var maj = {};
              cart.items.forEach(function (it) { maj[it.key] = it.quantity; });
              pieces.forEach(function (x) { maj[x.cle] -= 1; });
              requete('/cart/update.js', { updates: maj }).then(function () {
                if (window.__sfpAjoute) window.__sfpAjoute([{ id: idPack, quantity: 1 }]);
              });
            });
          }
        }
      }

      /* Coussin + plaid assortis au coloris du modèle (rien si un pack est déjà au panier) */
      assortis.innerHTML = '';
      var packPresent = cart.items.some(function (it) { return !!PACKS[it.handle]; });
      if (modele && !packPresent) {
        var coloris = null;
        (modele.options_with_values || []).forEach(function (o) { if (o.name === 'Coloris') coloris = o.value; });
        var accord = ACCORDS[coloris] || ACCORDS.Noir;
        [['coussin', accord[0], 'Le coussin assorti', NOMS[accord[0]] + ', 45 × 45 cm', 4500],
         ['plaid', accord[1], 'Le plaid assorti', NOMS[accord[1]] + ', 200 × 230 cm', 9900]].forEach(function (x) {
          var id = Number(D[x[0] + x[1].charAt(0).toUpperCase() + x[1].slice(1)]);
          if (!id || presente[id]) return;
          var li = document.createElement('li');
          li.className = 'sfp-panier__assorti';
          li.innerHTML = '<img src="' + D['img' + x[0].charAt(0).toUpperCase() + x[0].slice(1) + x[1].charAt(0).toUpperCase() + x[1].slice(1)] + '" alt="" width="48" height="48">' +
            '<p><strong>' + x[2] + '</strong> · ' + x[3] + '</p>' +
            '<button type="button" class="pill sfp-panier__ajout" aria-label="Ajouter ' + x[2].replace('Le ', 'le ') + ' ' + x[3] + ' au panier, ' + euros(x[4]) + '">+ ' + euros(x[4]) + '</button>';
          li.querySelector('button').addEventListener('click', function () { requete('/cart/add.js', { items: [{ id: id, quantity: 1 }] }); });
          assortis.appendChild(li);
        });
        /* Les deux à la fois : le Combo Cocon aux mêmes couleurs, 10 % de moins */
        var dejaCoussin = cart.items.some(function (it) { return it.handle === 'coussin-velours-cotele'; });
        var dejaPlaid = cart.items.some(function (it) { return it.handle === 'plaid-cocon'; });
        var pkCombo = PACKS['le-combo-cocon'];
        var idCombo = pkCombo ? varPack('le-combo-cocon', [NOMS[accord[0]], NOMS[accord[1]]]) : null;
        if (idCombo && !dejaCoussin && !dejaPlaid) {
          var liC = document.createElement('li');
          liC.className = 'sfp-panier__assorti sfp-panier__assorti--pack';
          liC.innerHTML = '<span class="sfp-panier__assorti-duo"><img src="' + D['imgCoussin' + accord[0].charAt(0).toUpperCase() + accord[0].slice(1)] + '" alt="" width="24" height="48"><img src="' + D['imgPlaid' + accord[1].charAt(0).toUpperCase() + accord[1].slice(1)] + '" alt="" width="24" height="48"></span>' +
            '<p><strong>Les deux en pack</strong> · ' + NOMS[accord[0]] + ' et ' + NOMS[accord[1]] + ', ' + euros(pkCombo.sep - pkCombo.prix) + ' de moins</p>' +
            '<button type="button" class="pill sfp-panier__ajout" aria-label="Ajouter le Combo Cocon, coussin ' + NOMS[accord[0]] + ' et plaid ' + NOMS[accord[1]] + ', au panier, ' + euros(pkCombo.prix) + '">+ ' + euros(pkCombo.prix) + '</button>';
          liC.querySelector('button').addEventListener('click', function () { requete('/cart/add.js', { items: [{ id: idCombo, quantity: 1 }] }); });
          assortis.appendChild(liC);
        }
      }

      /* Récapitulatif */
      articles.textContent = euros(cart.original_total_price);
      var rem = cart.original_total_price - cart.total_price;
      remiseLigne.hidden = rem <= 0;
      if (rem > 0) {
        var pressoOffert = cart.items.some(function (it) { return estPresso(it) && it.final_line_price === 0; });
        var pressoPrix = 0;
        cart.items.forEach(function (it) { if (estPresso(it)) pressoPrix = it.original_line_price; });
        remiseNom.textContent = pressoOffert && Math.abs(rem - pressoPrix) < 1 ? 'Presso offert' : 'Remises';
        remise.textContent = '−' + euros(rem);
      }
      frais.textContent = cart.total_price >= SEUIL_LIVRAISON ? 'Offerte' : euros(FRAIS);
      countUpMonnaie(total, dernierTotal, cart.total_price, euros(cart.total_price));
      dernierTotal = cart.total_price;
      commander.textContent = 'Passer commande · ' + euros(cart.total_price);
      return { net: net, presso: cart.items.filter(estPresso)[0] || null };
    };

    var requete = function (url, corps) {
      panier.classList.add('est-occupe');
      return fetch(url, corps ? {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps)
      } : undefined)
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var etat = rendu(cart);
          /* Presso automatique : ajouté au palier (sauf refus), retiré sous le palier s'il avait été ajouté pour le cadeau */
          if (etat.net >= SEUIL_PRESSO && !etat.presso && !lit('sfp-presso-refus')) {
            note('sfp-presso-auto', '1');
            return requete('/cart/add.js', { items: [{ id: PRESSO, quantity: 1 }] });
          }
          if (etat.net < SEUIL_PRESSO && etat.presso && lit('sfp-presso-auto')) {
            note('sfp-presso-auto', null);
            return requete('/cart/change.js', { id: etat.presso.key, quantity: 0 });
          }
          if (etat.net < SEUIL_PRESSO) note('sfp-presso-refus', null);
          return cart;
        })
        .finally(function () { panier.classList.remove('est-occupe'); });
    };
    var change = function (cle, quantite) { requete('/cart/change.js', { id: cle, quantity: quantite }); };

    ouvrePanier = function (depuis) {
      declencheur = depuis || null;
      /* La mise en avant de la ligne ajoutée démarre à l'ouverture du tiroir. */
      if (Date.now() - ajoutRecent.t < 5000) ajoutRecent.t = Date.now();
      panier.classList.add('est-ouvert');
      document.documentElement.style.overflow = 'hidden';
      if (window.__lenis) window.__lenis.stop();
      var f = panier.querySelector('.sfp-panier__fermer');
      if (f) f.focus();
      requete('/cart.js');
    };
    window.__sfpAjoute = function (items) {
      ajoutRecent = { ids: items.map(function (i) { return Number(i.id); }), t: Date.now() };
      return requete('/cart/add.js', { items: items });
    };
    panier.querySelectorAll('[data-sfp-panier-ferme]').forEach(function (el) { el.addEventListener('click', fermePanier); });
    document.addEventListener('keydown', function (e) {
      if (!panier.classList.contains('est-ouvert')) return;
      if (e.key === 'Escape') { fermePanier(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(panier.querySelectorAll('.sfp-panier__panneau a[href], .sfp-panier__panneau button:not([disabled])'),
        function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    var btnPanier = document.querySelector('[data-sfp-panier-btn]');
    if (btnPanier) {
      btnPanier.addEventListener('click', function (e) { e.preventDefault(); ouvrePanier(btnPanier); });
    }
    window.__sfpOuvrePanier = ouvrePanier;
  }

  /* Bouton d'ajout à états (parité EtatAjout.jsx du site) : Ajouter → anneau de
     chargement → coche tracée « Ajouté ». Largeur stable (gabarit invisible). */
  var poseEtat = function (bouton, etat, libelle) {
    var texte = libelle || bouton.dataset.texteAjouter || 'Ajouter au panier';
    var contenu = etat === 'busy'
      ? '<svg class="etat-ajout__anneau" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity=".28" stroke-width="2.4"/><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg><span class="sr-only">' + texte + ' : en cours</span>'
      : etat === 'ok'
        ? '<svg class="etat-ajout__coche" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Ajouté'
        : texte;
    bouton.dataset.etat = etat;
    bouton.setAttribute('aria-busy', String(etat === 'busy'));
    bouton.innerHTML = '<span class="etat-ajout"><span class="etat-ajout__gabarit" aria-hidden="true">' + texte + '</span><span class="etat-ajout__vue">' + contenu + '</span></span>';
    var vue = bouton.querySelector('.etat-ajout__vue');
    requestAnimationFrame(function () { requestAnimationFrame(function () { vue.classList.add('est-visible'); }); });
    if (etat === 'idle') { bouton.removeAttribute('data-etat'); bouton.style.background = ''; }
  };

  /* ══ FICHE PRODUIT ══ */
  document.querySelectorAll('[data-sfp-produit]').forEach(function (racine) {
    var json = racine.querySelector('[data-sfp-variantes]');
    var champId = racine.querySelector('[data-sfp-variant-id]');
    var selects = racine.querySelectorAll('[data-sfp-option]');
    if (!json || !champId) return;
    var variantes;
    try { variantes = JSON.parse(json.textContent); } catch (e) { return; }
    var prixEl = racine.querySelector('[data-sfp-prix]');
    var bouton = racine.querySelector('[data-sfp-ajouter]');
    var recap = racine.querySelector('[data-sfp-recap]');
    var upsell = racine.querySelector('[data-sfp-upsell]');
    var buybar = document.querySelector('[data-sfp-buybar]');
    var dernierCents = 0;
    var varianteActive = null;

    var choixActuels = function () {
      return Array.prototype.map.call(selects, function (s) { return s.value; });
    };
    var totalCents = function (v) {
      var t = v ? v.cents : 0;
      if (upsell && upsell.getAttribute('aria-pressed') === 'true') t += 4500;
      return t;
    };
    var maj = function (anime) {
      var choix = choixActuels();
      var v = variantes.find(function (variante) {
        return variante.options.every(function (opt, i) { return opt === choix[i]; });
      });
      if (!v) return;
      varianteActive = v;
      champId.value = v.id;
      /* Fiche technique : la référence suit la déclinaison choisie */
      var refEl = document.querySelector('[data-sfp-ref]');
      if (refEl && v.sku) refEl.textContent = v.sku;
      try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) { /* iframe sandbox */ }
      var final = euros(totalCents(v));
      if (prixEl) {
        if (anime) countUpMonnaie(prixEl, dernierCents, totalCents(v), final);
        else prixEl.textContent = final;
      }
      dernierCents = totalCents(v);
      if (bouton) {
        bouton.disabled = !v.dispo;
        if (!bouton.dataset.etatFige) {
          bouton.textContent = v.dispo ? bouton.dataset.texteAjouter : bouton.dataset.texteIndispo;
        }
      }
      if (recap) recap.textContent = 'Votre ' + racine.dataset.nom.replace(/^Le /, '') + ' · ' + choix.filter(function (c) { return c !== 'Default Title'; }).join(' · ') +
        (upsell && upsell.getAttribute('aria-pressed') === 'true' ? ' · + coussin' : '');
      if (buybar) {
        var bbNom = buybar.querySelector('[data-sfp-buybar-nom]');
        var bbPrix = buybar.querySelector('[data-sfp-buybar-prix]');
        if (bbNom) bbNom.textContent = racine.dataset.nom + ' · ' + choix.filter(function (c) { return c !== 'Default Title'; }).join(' · ');
        if (bbPrix) bbPrix.textContent = final;
        document.body.classList.toggle('has-buybar', !!v.dispo);
      }
      /* Packs : chaque pièce de la composition suit la couleur choisie */
      var compo = document.querySelector('[data-sfp-pack-compo]');
      if (compo) {
        var imgsPack = {};
        try { imgsPack = JSON.parse(document.querySelector('[data-sfp-pack-images]').textContent); } catch (e) { /* JSON absent */ }
        selects.forEach(function (s) {
          var piece = compo.querySelector('[data-option="' + s.dataset.nom + '"]');
          if (!piece) return;
          var img = piece.querySelector('img'), val = piece.querySelector('[data-valeur]:not(img)');
          var url = (imgsPack[piece.dataset.quoi] || {})[s.value];
          if (val) val.textContent = s.value;
          if (img && url && img.dataset.valeur !== s.value) {
            img.dataset.valeur = s.value;
            img.srcset = url + '&width=400 400w, ' + url + '&width=700 700w, ' + url + '&width=900 900w';
            img.src = url + '&width=900';
            img.alt = (piece.dataset.quoi === 'plaid' ? 'Plaid ' : 'Coussin ') + s.value.toLowerCase();
            piece.classList.remove('est-change'); void piece.offsetWidth; piece.classList.add('est-change');
          }
        });
      }
      /* Galerie pilotée par le coloris (vignettes data-coloris) */
      var coloris = null;
      selects.forEach(function (s) { if (s.dataset.nom === 'Coloris') coloris = s.value; });
      if (coloris) {
        var slug = coloris.toLowerCase().replace('è', 'e').replace('ø', 'o');
        var vignettes = document.querySelectorAll('[data-sfp-vignette][data-coloris]');
        var premiere = null;
        vignettes.forEach(function (vg) {
          var visible = vg.dataset.coloris === coloris;
          vg.hidden = !visible;
          if (visible && !premiere) premiere = vg;
        });
        if (anime && premiere) premiere.click();
        /* Accessoires (galerie native, sans data-coloris) : la photo suit le
           coloris par POSITION — les médias studio sont dans l'ordre des
           valeurs de l'option Coloris (terracotta, sauge, … / crème, camel). */
        if (!vignettes.length) {
          var selColoris = null;
          selects.forEach(function (s) { if (s.dataset.nom === 'Coloris') selColoris = s; });
          if (selColoris) {
            var idxColoris = Array.prototype.map.call(selColoris.options, function (o) { return o.value; }).indexOf(coloris);
            var natives = document.querySelectorAll('[data-sfp-vignette]');
            if (idxColoris > -1 && natives[idxColoris]) natives[idxColoris].click();
          }
        }
        var zoom = document.querySelector('[data-sfp-galerie] .sfp-galerie__zoom');
        if (zoom && zoom.getAttribute('data-zoom-' + slug)) {
          zoom.src = zoom.getAttribute('data-zoom-' + slug);
        }
        /* Coussin assorti : Terracotta sur Noir/Gris/Vert, Sauge sur Blanc/Crème */
        if (upsell && upsell.dataset.map) {
          try {
            var carte = JSON.parse(upsell.dataset.map)[coloris];
            if (carte) {
              upsell.dataset.varianteCoussin = carte[0];
              var nom = upsell.querySelector('[data-sfp-upsell-nom]');
              var dot = upsell.querySelector('[data-sfp-upsell-dot]');
              if (nom) nom.textContent = carte[1];
              if (dot) dot.style.background = carte[2];
              var aNom = racine.querySelector('[data-sfp-assorti-nom]'), aDot = racine.querySelector('[data-sfp-assorti-dot]');
              if (aNom) aNom.textContent = carte[1];
              if (aDot) aDot.style.background = carte[2];
            }
          } catch (err) { /* map illisible : on garde le défaut */ }
        }
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', function () { maj(true); }); });

    /* Onglets Coloris | Configuration */
    var onglets = racine.querySelector('[data-sfp-onglets]');
    if (onglets) {
      var trait = onglets.querySelector('.sfp-onglets__trait');
      var tabs = onglets.querySelectorAll('button[data-panneau]');
      var panneaux = racine.querySelectorAll('[data-sfp-panneau]');
      var positionne = function (tab) {
        if (!trait) return;
        trait.style.left = tab.offsetLeft + 'px';
        trait.style.width = tab.offsetWidth + 'px';
      };
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (o) { o.setAttribute('aria-selected', String(o === tab)); });
          panneaux.forEach(function (p) {
            var actif = p.dataset.sfpPanneau === tab.dataset.panneau;
            p.hidden = !actif;
            if (actif) { p.classList.remove('sfp-panneau-onglet'); void p.offsetWidth; p.classList.add('sfp-panneau-onglet'); }
          });
          positionne(tab);
        });
      });
      var actif = onglets.querySelector('button[aria-selected="true"]') || tabs[0];
      if (actif) requestAnimationFrame(function () { positionne(actif); });
    }
    /* Boutons d'option (swatches + pills) → selects cachés */
    racine.querySelectorAll('[data-sfp-choix]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var groupe = btn.closest('[data-sfp-panneau]');
        groupe.querySelectorAll('[data-sfp-choix]').forEach(function (o) {
          o.setAttribute('aria-pressed', String(o === btn));
          if (o.classList.contains('pill')) { o.classList.toggle('pill--nav', o === btn); o.classList.toggle('pill--ghost', o !== btn); }
        });
        var etiquette = groupe.querySelector('[data-sfp-choix-label]');
        if (etiquette) etiquette.textContent = btn.dataset.valeur;
        var select = racine.querySelector('[data-sfp-option][data-nom="' + groupe.dataset.nom + '"]');
        if (select) { select.value = btn.dataset.valeur; select.dispatchEvent(new Event('change')); }
      });
    });

    /* Up-sell coussin (+45 €) */
    if (upsell) {
      upsell.addEventListener('click', function () {
        var actif = upsell.getAttribute('aria-pressed') !== 'true';
        upsell.setAttribute('aria-pressed', String(actif));
        maj(true);
      });
    }

    /* Bouton magnétique (delta ×0.35, lerp rAF) */
    if (bouton && !rm && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var bx = 0, by = 0, tx = 0, ty = 0, actifMag = false;
      var boucleMag = function () {
        bx += (tx - bx) * 0.15; by += (ty - by) * 0.15;
        bouton.style.transform = 'translate(' + bx + 'px,' + by + 'px)';
        if (actifMag || Math.abs(bx) > 0.1 || Math.abs(by) > 0.1) requestAnimationFrame(boucleMag);
        else bouton.style.transform = '';
      };
      bouton.addEventListener('mousemove', function (e) {
        var r = bouton.getBoundingClientRect();
        tx = (e.clientX - r.left - r.width / 2) * 0.35;
        ty = (e.clientY - r.top - r.height / 2) * 0.35;
        if (!actifMag) { actifMag = true; requestAnimationFrame(boucleMag); }
      });
      bouton.addEventListener('mouseleave', function () { tx = 0; ty = 0; actifMag = false; requestAnimationFrame(boucleMag); });
    }

    /* Ajout AJAX : états, fly-to-cart, ouverture du tiroir */
    var form = racine.querySelector('form[action*="/cart/add"]');
    if (form && window.__sfpAjoute) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!varianteActive || !varianteActive.dispo) return;
        var items = [{ id: varianteActive.id, quantity: 1 }];
        if (upsell && upsell.getAttribute('aria-pressed') === 'true' && upsell.dataset.varianteCoussin) {
          items.push({ id: Number(upsell.dataset.varianteCoussin), quantity: 1 });
        }
        if (bouton) {
          bouton.dataset.etatFige = '1';
          bouton.disabled = true;
          poseEtat(bouton, 'busy');
        }
        window.__sfpAjoute(items).then(function () {
          if (bouton) poseEtat(bouton, 'ok');
          setTimeout(function () {
            if (window.__sfpOuvrePanier) window.__sfpOuvrePanier(bouton);
          }, 420);
          setTimeout(function () {
            if (!bouton) return;
            poseEtat(bouton, 'idle');
            bouton.disabled = false;
            delete bouton.dataset.etatFige;
          }, 1600);
        }).catch(function () {
          if (!bouton) return;
          poseEtat(bouton, 'idle', 'Réessayer l\'ajout');
          bouton.disabled = false;
          delete bouton.dataset.etatFige;
        });
      });
    }

    maj(false);
  });

  /* ── Galerie fiche : crossfade vignettes + lightbox + overlay packshot ── */
  document.querySelectorAll('[data-sfp-galerie]').forEach(function (galerie) {
    var cadre = galerie.querySelector('.sfp-cadre');
    var principale = galerie.querySelector('[data-sfp-galerie-principale]');
    var vignettes = galerie.querySelectorAll('[data-sfp-vignette]');
    var overlay = galerie.querySelector('[data-sfp-overlay-cotes]');
    if (!principale || !vignettes.length) return;
    var montre = function (v) {
      vignettes.forEach(function (o) { o.classList.toggle('est-active', o === v); });
      if (overlay) overlay.hidden = v.dataset.type !== 'packshot';
      if (cadre) cadre.classList.toggle('a-zoom', v.dataset.type === 'affichage');
      if (rm || !principale.animate) { principale.src = v.dataset.src; return; }
      var fantome = principale.cloneNode();
      fantome.src = v.dataset.src;
      fantome.className = 'sfp-galerie__calque';
      fantome.style.opacity = '0';
      fantome.removeAttribute('data-sfp-galerie-principale');
      principale.parentNode.appendChild(fantome);
      requestAnimationFrame(function () {
        fantome.style.opacity = '1';
        setTimeout(function () { principale.src = v.dataset.src; fantome.remove(); }, 320);
      });
    };
    vignettes.forEach(function (v) {
      v.addEventListener('click', function () { montre(v); });
    });

    /* Lightbox */
    var lightbox = document.querySelector('[data-sfp-lightbox]');
    if (lightbox && cadre) {
      var lbImg = lightbox.querySelector('img[data-sfp-lb-img]');
      var lbVigs = lightbox.querySelectorAll('[data-sfp-lb-vignette]');
      var idx = 0;
      var visibles = function () {
        return Array.prototype.filter.call(vignettes, function (v) { return !v.hidden; });
      };
      var montreLb = function (n) {
        var vs = visibles();
        idx = ((n % vs.length) + vs.length) % vs.length;
        if (lbImg) {
          lbImg.classList.remove('est-active');
          lbImg.onload = function () { lbImg.classList.add('est-active'); };
          lbImg.src = vs[idx].dataset.src;
        }
        lbVigs.forEach(function (b, i) {
          b.classList.toggle('est-active', i === idx);
          b.hidden = i >= vs.length;
          var im = b.querySelector('img');
          if (im && vs[i]) im.src = vs[i].dataset.src;
        });
      };
      var ouvreLb = function () {
        lightbox.classList.add('est-ouverte');
        document.body.style.overflow = 'hidden';
        var f = lightbox.querySelector('.sfp-lightbox__fermer');
        if (f) f.focus();
        var vs = visibles();
        var actIdx = vs.findIndex(function (v) { return v.classList.contains('est-active'); });
        montreLb(actIdx < 0 ? 0 : actIdx);
      };
      var fermeLb = function () {
        lightbox.classList.remove('est-ouverte');
        document.body.style.overflow = '';
      };
      cadre.addEventListener('click', ouvreLb);
      cadre.setAttribute('role', 'button');
      cadre.setAttribute('tabindex', '0');
      cadre.addEventListener('keydown', function (e) { if (e.key === 'Enter') ouvreLb(); });
      lightbox.querySelectorAll('[data-sfp-lb-ferme]').forEach(function (el) {
        el.addEventListener('click', fermeLb);
      });
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) fermeLb(); });
      lightbox.querySelectorAll('[data-sfp-lb-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () { montreLb(idx + Number(btn.dataset.sfpLbNav)); });
      });
      lbVigs.forEach(function (b, i) {
        b.addEventListener('click', function () { montreLb(i); });
      });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('est-ouverte')) return;
        if (e.key === 'Escape') fermeLb();
        if (e.key === 'ArrowLeft') montreLb(idx - 1);
        if (e.key === 'ArrowRight') montreLb(idx + 1);
      });
    }

    /* Buybar : visible dès que le visuel principal est sorti de l'écran */
    var buybar = document.querySelector('[data-sfp-buybar]');
    if (buybar && cadre) {
      var majBuybar = function () {
        var visible = cadre.getBoundingClientRect().bottom < 0;
        buybar.classList.toggle('buybar--visible', visible);
        buybar.setAttribute('aria-hidden', String(!visible));
      };
      window.addEventListener('scroll', majBuybar, { passive: true });
      majBuybar();
    }
  });

  /* ── Schéma des dimensions : SVG FACE + PROFIL (port exact de
        DimensionsSchema.jsx — aire 460×288, X24, maxW 304, maxH 172, yBase 208),
        reveal séquencé .15/.3/.45s via IO -12%. ── */
  document.querySelectorAll('[data-sfp-schema]').forEach(function (schema) {
    var W = parseFloat(schema.dataset.l) || 0;
    var D = parseFloat(schema.dataset.p) || 0;
    var H = parseFloat(schema.dataset.h) || null;
    var assise = parseFloat(schema.dataset.assise) || null;
    var sans = schema.dataset.sansAccoudoirs === 'true';
    if (!W || !D) return;
    var X = 24, maxW = 304, maxH = 172, yBase = 208;
    var fmt = function (v) { return String(v).replace('.', ','); };
    var fleche = function (uid) {
      return '<defs><marker id="' + uid + '" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6.5" markerHeight="6.5" orient="auto-start-reverse">' +
        '<path d="M0,0 L10,5 L0,10 z" fill="var(--brand)"/></marker></defs>';
    };
    var coteH = function (x0, len, label, uid) {
      return '<g class="sfp-cote sfp-cote--1"><g stroke="var(--brand)" stroke-width="2.4">' +
        '<line x1="' + x0 + '" y1="' + (yBase + 18) + '" x2="' + x0 + '" y2="' + (yBase + 38) + '"/>' +
        '<line x1="' + (x0 + len) + '" y1="' + (yBase + 18) + '" x2="' + (x0 + len) + '" y2="' + (yBase + 38) + '"/>' +
        '<line x1="' + (x0 + 8) + '" y1="' + (yBase + 28) + '" x2="' + (x0 + len - 8) + '" y2="' + (yBase + 28) + '" marker-start="url(#' + uid + ')" marker-end="url(#' + uid + ')"/></g>' +
        '<text x="' + (x0 + len / 2) + '" y="' + (yBase + 70) + '" text-anchor="middle" class="tnum" fill="var(--ink)" font-size="25" font-weight="700">' + label + '</text></g>';
    };
    var coteV = function (x, top, label, uid) {
      return '<g class="sfp-cote sfp-cote--2"><g stroke="var(--brand)" stroke-width="2.4">' +
        '<line x1="' + (x - 12) + '" y1="' + top + '" x2="' + (x + 12) + '" y2="' + top + '"/>' +
        '<line x1="' + (x - 12) + '" y1="' + yBase + '" x2="' + (x + 12) + '" y2="' + yBase + '"/>' +
        '<line x1="' + x + '" y1="' + (top + 8) + '" x2="' + x + '" y2="' + (yBase - 8) + '" marker-start="url(#' + uid + ')" marker-end="url(#' + uid + ')"/></g>' +
        '<text x="' + (x + 20) + '" y="' + ((top + yBase) / 2 + 8) + '" class="tnum" fill="var(--ink)" font-size="25" font-weight="700">' + label + '</text></g>';
    };
    var visH = H || Math.round(W * 0.72);
    /* Vue de face */
    var s1 = Math.min(maxW / Math.max(W, 1), maxH / Math.max(visH, 1));
    var sw = W * s1, sh = visH * s1;
    var fx0 = X + (maxW - sw) / 2, ftop = yBase - sh;
    var arm = sans ? 0 : Math.min(46, Math.max(26, sw * 0.11));
    var seatH = sh * 0.46;
    var face = '<svg viewBox="0 0 460 288" aria-hidden="true" style="width:100%;display:block;">' + fleche('sfp-fl-face') +
      '<g fill="var(--paper)" stroke="var(--green)" stroke-width="3" stroke-linejoin="round">' +
      '<rect x="' + (fx0 + arm * 0.55) + '" y="' + ftop + '" width="' + (sw - arm * 1.1) + '" height="' + (sh - seatH + 12) + '" rx="12"/>' +
      '<rect x="' + fx0 + '" y="' + (yBase - seatH) + '" width="' + sw + '" height="' + seatH + '" rx="11"/>' +
      (sans ? '' :
        '<rect x="' + (fx0 - 3) + '" y="' + (yBase - seatH - 18) + '" width="' + arm + '" height="' + (seatH + 18) + '" rx="10"/>' +
        '<rect x="' + (fx0 + sw - arm + 3) + '" y="' + (yBase - seatH - 18) + '" width="' + arm + '" height="' + (seatH + 18) + '" rx="10"/>') +
      '</g><g stroke="var(--green)" stroke-width="4" stroke-linecap="round">' +
      '<line x1="' + (fx0 + 16) + '" y1="' + yBase + '" x2="' + (fx0 + 16) + '" y2="' + (yBase + 9) + '"/>' +
      '<line x1="' + (fx0 + sw - 16) + '" y1="' + yBase + '" x2="' + (fx0 + sw - 16) + '" y2="' + (yBase + 9) + '"/></g>' +
      coteH(fx0, sw, fmt(W) + ' cm', 'sfp-fl-face') +
      (H ? coteV(fx0 + sw + 24, ftop, fmt(H) + ' cm', 'sfp-fl-face') : '') + '</svg>';
    /* Vue de profil */
    var s2 = Math.min(maxW / Math.max(D, 1), maxH / Math.max(visH, 1));
    var sd = D * s2, sh2 = visH * s2;
    var px0 = X + (maxW - sd) / 2, ptop = yBase - sh2;
    var backW = Math.max(30, sd * 0.24);
    var bodyH = sh2 * 0.62;
    var yA = assise ? yBase - assise * s2 : null;
    var profil = '<svg viewBox="0 0 460 288" aria-hidden="true" style="width:100%;display:block;">' + fleche('sfp-fl-profil') +
      '<g fill="var(--paper)" stroke="var(--green)" stroke-width="3" stroke-linejoin="round">' +
      '<rect x="' + (px0 + sd - backW) + '" y="' + ptop + '" width="' + backW + '" height="' + sh2 + '" rx="12"/>' +
      '<rect x="' + px0 + '" y="' + (yBase - bodyH) + '" width="' + (sd - backW * 0.45) + '" height="' + bodyH + '" rx="11"/>' +
      '</g><g stroke="var(--green)" stroke-width="4" stroke-linecap="round">' +
      '<line x1="' + (px0 + 14) + '" y1="' + yBase + '" x2="' + (px0 + 14) + '" y2="' + (yBase + 9) + '"/>' +
      '<line x1="' + (px0 + sd - 14) + '" y1="' + yBase + '" x2="' + (px0 + sd - 14) + '" y2="' + (yBase + 9) + '"/></g>' +
      (yA ? '<g class="sfp-cote sfp-cote--3">' +
        '<line x1="' + (px0 - 6) + '" y1="' + yA + '" x2="' + (px0 + sd + 6) + '" y2="' + yA + '" stroke="var(--sage)" stroke-width="2.2" stroke-dasharray="7 6"/>' +
        '<text x="' + (px0 + sd + 14) + '" y="' + (yA - 5) + '" class="tnum" fill="var(--green)" font-size="24" font-weight="600">' +
        '<tspan x="' + (px0 + sd + 14) + '" dy="0">assise</tspan>' +
        '<tspan x="' + (px0 + sd + 14) + '" dy="26">' + fmt(assise) + ' cm</tspan></text></g>' : '') +
      coteH(px0, sd, fmt(D) + ' cm', 'sfp-fl-profil') + '</svg>';
    schema.innerHTML =
      '<figure>' + face + '<figcaption>Vue de face</figcaption></figure>' +
      '<figure>' + profil + '<figcaption>Vue de profil</figcaption></figure>';

    if (rm || !('IntersectionObserver' in window)) { schema.classList.add('est-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { schema.classList.add('est-visible'); io.disconnect(); }
    }, { rootMargin: '0px 0px -12% 0px' });
    io.observe(schema);
  });

  /* ── Reveals (rootMargin -8%, visible immédiatement si déjà à l'écran) ── */
  var cibles = document.querySelectorAll('.sfp-reveal, .sfp-reveal--gauche, .sfp-reveal--droite, .sfp-reveal--txt-gauche, .sfp-reveal--txt-droite');
  if (cibles.length) {
    if (rm || !('IntersectionObserver' in window)) {
      cibles.forEach(function (el) { el.classList.add('est-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('est-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      cibles.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add('est-visible');
        else io.observe(el);
      });
    }
  }
})();
